import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

export const CheckBoxField = ({
  checked,
  onChange,
  disabled = false,
  label = 'Transform in original column (overwrite source data)',
  name = 'transformInPlace',
}) => {
  const handleChange = (e) => {
    onChange(e.target.checked);
  };
  return (
    <FormControlLabel
      control={<Checkbox checked={checked} onChange={handleChange} disabled={disabled} name={name} color="primary" />}
      label={label}
    />
  );
};
